import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import project1 from '../../../images/rsz_schoz.png';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons'
import './AllProject.css';

const AllProject = () => {
    return (
        <main>
            <div className="container">
                <div className="mb-5">
                    <h2 className="page-title text-left mb-5">My Works</h2>
                    <div className="card-deck zoom-effect-container mb-5">
                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                    </div>



                    <div className="card-deck zoom-effect-container mt-5">
                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div className="card cardColor zoom-effect">
                            <article>
                                <img className="card-img-top" src={project1} alt="" />
                                <div className="card-body">
                                    <div className="card-title h5">Shohoz Sheba</div>
                                    <p className="small card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis tempora sequi optio quod et accusantium repellat in quisquam fugit nihil.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technology">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Express.js</span>
                                            <span>MongoDb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://github.com/Tanjin9185?tab=repositories" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>


                        



                    </div>





                </div>
            </div>
        </main>
    );
};

export default AllProject;